import styled, { css } from 'styled-components';

type ButtonWrapperProps = {
  secondary?: boolean;
  filter?: boolean;
};

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  @media (max-width: 768px) {
    justify-content: space-evenly;

    ${(props) =>
      props.filter &&
      css`
        justify-content: flex-end;
      `}
  }

  ${(props) =>
    props.secondary &&
    css`
      justify-content: flex-end;
    `}
`;

export const CardContainer = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  grid-gap: 3rem;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    gap: 2rem;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  flex-direction: row;

  font-size: 0;
  background: transparent;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

type FilterLabelProps = {
  filter?: boolean;
};

export const FilterLabel = styled.p<FilterLabelProps>`
  font-size: 1.8rem;
  color: #fff;
  margin-right: 0.92rem;

  @media (max-width: 768px) {
    display: none;

    ${(props) =>
      props.filter &&
      css`
        display: flex;
      `}
  }
`;

export const ModalFilterContent = styled.div`
  width: 100%;
  max-width: 40rem;
`;

export const ModalQuestion = styled.div`
  width: 100%;
  max-width: 38.4rem;
  margin: 0 auto;

  > h2 {
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.7rem;
    color: #000000;

    margin-left: 2rem;
  }

  .date_register {
    display: flex;
    width: 100%;

    margin: 0.8rem 0 2.3rem;

    > input {
      width: 100%;
      height: 4.7rem;
      border-radius: 8rem;
      border: 0.2px solid #707070;
      padding-left: 2.2rem;

      font-size: 2rem;
      line-height: 1.7rem;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      & + input {
        margin-left: 1.2rem;
      }
      /* width: 12rem; */
    }
  }

  .status {
    display: flex;

    margin: 1.3rem 4rem 3.5rem;
  }
`;

export const ModalTitle = styled.h1`
  font-size: 3.4rem;
  letter-spacing: 0.17rem;
  line-height: 2.9rem;
  text-transform: uppercase;
  color: #000000;

  text-align: center;
  margin-bottom: 4.1rem;
`;

export const NewButtonContainer = styled.div`
  margin-bottom: 3.2rem;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;

export const NoDataFound = styled.div`
  width: 100%;
  text-align: center;

  margin-top: 10%;

  p {
    font-size: 2rem;
    color: white;
  }
`;
